import React from "react";
import YouTube from 'react-youtube';

const YTPlayer = (p) => {
  const noop = () => {}
  return (
    // rotate by 90 deg for horizontal video
    <YouTube
      videoId={p.videoid}                  // defaults -> null
      id={p.id}                       // defaults -> null
      className={p.className}                // defaults -> null
      containerClassName={p.containerClassName}       // defaults -> ''
      opts={p.opts}                        // defaults -> {}
      onReady={p.onReady || noop}                    // defaults -> noop
      onPlay={p.onPlay || noop}                     // defaults -> noop
      onPause={p.onPause || noop}                    // defaults -> noop
      onEnd={p.onEnd || noop}                      // defaults -> noop
      onError={p.onError || noop}                    // defaults -> noop
      onStateChange={p.onStateChange || noop}              // defaults -> noop
      onPlaybackRateChange={p.onPlaybackRateChange || noop}       // defaults -> noop
      onPlaybackQualityChange={p.onPlaybackQualityChange || noop}    // defaults -> noop
    />
  );
}

export default YTPlayer